module.exports = __webpack_public_path__ + "static/media/add-users.2dab9bf7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/add-users.svg
// module id = 451
// module chunks = 0